import styled from '@emotion/styled';
import { theme } from '../../constants/theme';

export const StyledDatePicker = styled.div`
  width: ${props => props.$fullWidth ? '100%' : 'auto'};

  .MuiTextField-root {
    ${props => {
      const sizes = {
        sm: `
          .MuiInputBase-root {
            height: ${theme.sizes.input.sm};
            font-size: ${theme.typography.fontSize.xs};
          }
        `,
        md: `
          .MuiInputBase-root {
            height: ${theme.sizes.input.md};
            font-size: ${theme.typography.fontSize.sm};
          }
        `,
        lg: `
          .MuiInputBase-root {
            height: ${theme.sizes.input.lg};
            font-size: ${theme.typography.fontSize.md};
          }
        `,
      };
      return sizes[props.$size] || sizes.md;
    }}

    .MuiInputBase-root {
      border-radius: ${theme.borderRadius.sm};
      transition: ${theme.transitions.duration.normal} ${theme.transitions.timing.easeInOut};

      &:hover {
        .MuiOutlinedInput-notchedOutline {
          border-color: ${theme.colors.primary.main};
        }
      }

      &.Mui-focused {
        .MuiOutlinedInput-notchedOutline {
          border-color: ${theme.colors.primary.main};
          border-width: 2px;
        }
      }

      &.Mui-error {
        .MuiOutlinedInput-notchedOutline {
          border-color: ${theme.colors.error.main};
        }
      }

      &.Mui-disabled {
        background-color: ${theme.colors.gray[100]};
        cursor: not-allowed;
      }
    }

    .MuiInputLabel-root {
      color: ${theme.colors.text.secondary};
      font-weight: ${theme.typography.fontWeight.medium};

      &.Mui-focused {
        color: ${theme.colors.primary.main};
      }

      &.Mui-error {
        color: ${theme.colors.error.main};
      }
    }

    .MuiFormHelperText-root {
      margin-left: 0;
      margin-top: ${theme.spacing.xs};
      font-size: ${theme.typography.fontSize.xs};
      
      &.Mui-error {
        color: ${theme.colors.error.main};
      }
    }
  }

  .MuiPickersDay-root {
    &.Mui-selected {
      background-color: ${theme.colors.primary.main};
      color: ${theme.colors.white};

      &:hover {
        background-color: ${theme.colors.primary.dark};
      }
    }
  }
`;
